import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/report';

// GETBYIDDONWLOAD
function reportDonwload(state, action) {
  state.getByIdDonwload.buffer = action.payload.buffer ? action.payload.buffer:"";
  state.getByIdDonwload.result = action.payload.result ? action.payload.result:false;
}

function conexionReportDonwload(state, action) {
  state.getByIdDonwload.connection= action.payload.connection;
}

function errorgReportDonwload(state, action) {
  state.getByIdDonwload.error= action.payload.error ? action.payload.error:false;
  state.getByIdDonwload.message= action.payload.message ? action.payload.message:"";
}

function reportDonwloadReset(state, action) {
  state.getByIdDonwload.buffer=""
  state.getByIdDonwload.result=false;
  state.getByIdDonwload.connection= false;
  state.getByIdDonwload.error= false;
  state.getByIdDonwload.message= "";
}

/**
 * Conexión
 */
const reportReducer = createSlice({
  name: 'report',
  initialState: initState,
  reducers: {
    // GETBYIDDONWLOAD
    reportDonwload,
    conexionReportDonwload,
    errorgReportDonwload,
    reportDonwloadReset
  },
});

export const reportActions = {
  ...reportReducer.actions,
};

export default reportReducer.reducer;
